<template>
  <div class="skeleton-loading-bars">
    <aha-skeleton-loader
      class="skeleton-bar"
      width="90%"
      height="12px"
    />
    <aha-skeleton-loader
      class="skeleton-bar"
      width="70%"
      height="12px"
    />
    <aha-skeleton-loader
      class="skeleton-bar"
      width="30%"
      height="12px"
    />
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.skeleton-loading-bars {
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 11px 0px rgba(0,0,0,0.08);

  .skeleton-bar + .skeleton-bar {
    margin-top: 0.5rem;
  }
}

.skeleton-loading-bars + .skeleton-loading-bars {
  margin-top: 28px;
}
</style>
